module.exports = __webpack_public_path__ + "static/img/2015-05-23 11.57.41.c35f1be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2015-05-23 11.57.41.jpg
// module id = ys9l
// module chunks = 4